import CONFIG from '@config/Config'

export const isProduction = CONFIG.environment === 'production'

export const sleep = async (ms = 0) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}
